import { IAppState } from '../../types';

export const selectNewbuildingRecommendations = (state: IAppState) => {
  return state.newbuildingRecommendations.data;
};
